import {
    ChannelSubscription,
    ChannelSubscriptionState,
    ChannelSubscriptionType,
} from '../shared/types';
import moment from 'moment';

export const userChannelSubscriptionPaymentFailed = (
    status: ChannelSubscriptionState
) => status === 'paymentFailed';

export const isNonChargeChannelSubscriptionType = (
    subscriptionType: ChannelSubscriptionType | undefined
) => subscriptionType === ChannelSubscriptionType.NonCharge;
export const isAccountChannelSubscriptionType = (
    subscriptionType: ChannelSubscriptionType | undefined
) => subscriptionType === ChannelSubscriptionType.Account;
export const isStripeChannelSubscriptionType = (
    subscriptionType: ChannelSubscriptionType | undefined
) => subscriptionType === ChannelSubscriptionType.Stripe;
export const isExternalBillingChannelSubscriptionType = (
    subscriptionTypeValue: ChannelSubscriptionType | undefined
) => subscriptionTypeValue === ChannelSubscriptionType.External;
export const isTrialChannelSubscriptionType = (
    subscriptionTypeValue: ChannelSubscriptionType | undefined
) => subscriptionTypeValue === ChannelSubscriptionType.Trial;

export const isSubscriptionExpired = (cs: ChannelSubscription | undefined) =>
    moment() > moment(cs?.cancelAt);

export const isSameChannelSubscriptionTypeSelected = (
    subscriptionType: ChannelSubscriptionType | undefined,
    currentSubscriptionType: ChannelSubscriptionType | undefined
) => {
    if (
        isNonChargeChannelSubscriptionType(subscriptionType) &&
        isNonChargeChannelSubscriptionType(currentSubscriptionType)
    )
        return true;
    if (
        isAccountChannelSubscriptionType(subscriptionType) &&
        isAccountChannelSubscriptionType(currentSubscriptionType)
    )
        return true;
    if (
        isExternalBillingChannelSubscriptionType(subscriptionType) &&
        isExternalBillingChannelSubscriptionType(currentSubscriptionType)
    )
        return true;

    return false;
};

export const isSubscriptionActive = (cs: ChannelSubscription) => {
    return (
        cs.subscriptionState !== 'canceled' &&
        cs.subscriptionState !== 'rejected' &&
        cs.subscriptionState !== 'expired' &&
        cs.subscriptionState !== 'pending' &&
        cs.subscriptionState !== 'paymentFailed' &&
        !isSubscriptionExpired(cs)
    );
};

export const isPaidSubscription = (cs: ChannelSubscription) =>
    cs.subscriptionType === ChannelSubscriptionType.Stripe ||
    cs.subscriptionType === ChannelSubscriptionType.External ||
    (cs.subscriptionType === ChannelSubscriptionType.Account && !cs.rebate);

export const isRebatedAccountSubscription = (cs: ChannelSubscription) =>
    cs.subscriptionType === ChannelSubscriptionType.Account && cs.rebate;

export const hasPendingCancellation = (cs: ChannelSubscription) => {
    return cs.subscriptionState === 'canceled' && !isSubscriptionExpired(cs);
};

export const getChannelSubscriptionCancelAtDateToShow = (
    cs: ChannelSubscription
): Date | null => {
    if (!cs.cancelAt) return null;

    return new Date(new Date(cs.cancelAt).setUTCHours(0, 0, 0, 0));
};

export const isActivePaidSubscription = (cs: ChannelSubscription) => {
    return (
        cs.subscriptionState === 'active' &&
        isPaidSubscription(cs) &&
        !isSubscriptionExpired(cs)
    );
};
